const KEY = "selected_restaurant";
export const getSelectedRestaurant = () => sessionStorage.getItem(KEY);
export function selectRestaurant(id: string) {
  sessionStorage.setItem(KEY, id);
}
export function clearSelectedRestaurant() {
  sessionStorage.removeItem(KEY);
  sessionStorage.removeItem('platform_restaurant_scope');
}
